import AlertSystemManagement from "./alert-system-management.page";

export default AlertSystemManagement;
